import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../../Components/Loading";
import Table from "../../Components/Applications/Table";
import Navbar from "../../Components/Navbar";
import Config from "../../Config";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Campaigns/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import UpdateStatusModel from "../../Components/Applications/ConsentModel";
import UploadCertificateModel from "../../Components/Applications/UploadCertificateModel";
//import SingleEntry from "../../Components/Campaigns/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { toast } from "react-toastify";
import ViewModel from "../../Components/Applications/ViewModel";
import ViewRemarksModel from "../../Components/Applications/ViewRemarksModel";
import { useTranslation } from "react-i18next";

const Applications = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);
  //const [searchValue, setSearchValue] = useState(email || "");
  const [selectedData, setSelectedData] = useState("");

  const [filterValue, setFilterValue] = useState("");
    const [filter, setFilter] = useState("0");
    const [searchType, setSearchType] = useState("0");
  const [openViewModel, setOpenViewModel] = useState(false);
  const [openViewRemarksModel, setOpenViewRemarksModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateStatusModel, setOpenUpdateStatusModel] = useState(false);
  const [openUploadCertificateModel, setOpenUploadCertificateModel] =
    useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [paymentData, setPaymentData] = useState("");

  const [editDevice, setEditDevice] = useState(false);

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { id } = useParams();

  // // ----- Getting Initial Data ------
  const fetchFunction = async (value) => {
    // console.log(value);
    
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    // body.append("status", value);
    body.append("filter", filter);
    body.append("filterValue", filterValue || "");
    return await axios.post(`${Config.apiUrl}/listapplications`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  // const { isLoading, error, data, refetch, isRefetching } = useQuery(
  //   "getMyRequestsList",
  //   fetchFunction
  // );

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    getAppRegMutate(searchType);
  }, []);

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getAppRegMutate(searchType);
    //getReportsMutate(newValues);
  };

  const searchHandler = (value) => {
    setSearchType(value);
    getAppRegMutate(value);
    //getReportsMutate(newValues);
  };

  /************ Generate Digital Certificate *************/

  const generateCertificateApi = async (values) => {
    const body = new FormData();
    body.append("appId", values.id);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/generatecertificate`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onGenerateCertificateSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      getAppRegMutate(searchType);
    } else toast.error(res?.data?.msg || "Error");
  };

  const onGenerateCertificateError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: GenerateCertificateLoading, mutate: generateCertificate } =
    useMutation(generateCertificateApi, {
      onSuccess: onGenerateCertificateSuccess,
      onError: onGenerateCertificateError,
    });

  /******************* End Geneate Digital Certificate ***********************************/
  /****** Open Consent Model *******/
  const openConsentModel = (values) => {
    getPaymentDetails(values);
    //getReportsMutate(newValues);
  };

  const timeout = (delay) => {
    return new Promise((res) => setTimeout(res, delay));
  };

  const getPaymentDetailApi = async (values) => {
    //await timeout(200);
    const body = new FormData();
    body.append("userType", user.userType);
    body.append("assocId", values.id);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/getpaymentdetails`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onGetPaymentDetailSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      setPaymentData(res?.data?.list);
      setOpenUpdateStatusModel(true);
    } else {
      setPaymentData("");
      setOpenUpdateStatusModel(true);
      //toast.error(res?.data?.msg || "Error");
    }
  };

  const onGetPaymentDetailError = (res) => {
    setOpenUpdateStatusModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: GetPaymentDetailLoading, mutate: getPaymentDetails } =
    useMutation(getPaymentDetailApi, {
      onSuccess: onGetPaymentDetailSuccess,
      onError: onGetPaymentDetailError,
    });

  /****** End Open Consent Model *******/

  //------- Update Status -------
  const UpdateStatusFunction = async (values) => {
    const body = new FormData();
    body.append("email", user.email);
    body.append("userType", user.userType);
    body.append("id", values.id);
    body.append("remarks", values.remarks);
    body.append("status", values.status);
    body.append("consent", values.consent);
    return await axios.post(`${Config.apiUrl}/updateassociationstatus`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateStatusSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenUpdateStatusModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUpdateStatusError = (res) => {
    setOpenUpdateStatusModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: UpdateStatusLoading, mutate: postUpdateStatus } =
    useMutation(UpdateStatusFunction, {
      onSuccess: onUpdateStatusSuccess,
      onError: onUpdateStatusError,
    });

  //------- Upload Certificate -------
  const UploadCertificateFunction = async (values) => {
    const body = new FormData();
    //body.append("token", user.token);
    body.append("appId", values.appId);
    body.append("cerificate", values.fileName);
    body.append("serviceType", 0);
    return await axios.post(`${Config.apiUrl}/uploadcert`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadCertificateSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenUploadCertificateModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUploadCertificateError = (res) => {
    setOpenUploadCertificateModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: UploadCertificateLoading, mutate: postUploadCertificate } =
    useMutation(UploadCertificateFunction, {
      onSuccess: onUploadCertificateSuccess,
      onError: onUploadCertificateError,
    });

  // deleteApi start

  const deleteDeviceHandler = async (values) => {
    const body = new FormData();
    body.append("id", values?.id);
    return await axios.post(
      // Config.DeleteDeviceApi,
      `${Config.apiUrl}/deleteapp`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
      // { selectedData: id, status: 0 },
      // Config.AxiosConfig
    );
  };

  const onDeleteDeviceSuccess = (data) => {
    if (data?.data?.status == "OK") {
      getAppRegMutate(searchType);
      // refetch();
      setSelectedItem("");
      setOpenDeleteModel(false);
      // console.log("success", data);
      toast.success(data?.data?.msg || "Success");
    } else toast.error(data?.data?.msg || "Error");
  };

  const onDeleteDeviceError = (data) => {
    setOpenDeleteModel(false);
    setSelectedItem("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteDeviceLoading, mutate: deleteDeviceMutate } =
    useMutation(deleteDeviceHandler, {
      onSuccess: onDeleteDeviceSuccess,
      onError: onDeleteDeviceError,
    });

  // end

  
  const submitHandlerTypeSearch = (values) => {
    {
      setFilterValue(values.filterVal);
    }
    // console.log(values);
    // console.log(filter);
    // console.log(filterValue);
    getAppRegMutate(values);
    //refetch();
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Applications")}</Title>
              <Underline />
            </div>
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          <div className="flex items-end justify-between">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
              t={t}
            />
            <TypeFilters
              filter={filter}
              submitHandlerTypeSearch={submitHandlerTypeSearch}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              user={user}
              t={t}
            />
            
            {/* <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
              <Label htmlFor="startDate">{t("Status")}</Label>
              <Select
                autoComplete="off"
                className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                style={{ height: "40px" }}
                value={searchType}
                onChange={(e) => searchHandler(e.target.value)}
              >
                <MenuItem value="0">All</MenuItem>
                <MenuItem value="1">Pending Docs</MenuItem>
                <MenuItem value="2">Pending Payments</MenuItem>
                <MenuItem value="3">InProgress</MenuItem>
                <MenuItem value="4">Approved By Asst</MenuItem>
                <MenuItem value="5">Completed</MenuItem>
                <MenuItem value="6">Certificate Issued</MenuItem>
                <MenuItem value="10">Rejected</MenuItem>
              </Select>
            </InputGroup> */}
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>
          {/* {openDeleteModel && (
          <DeleteModel
            deleteDeviceLoading={deleteDeviceLoading}
            setOpenDeleteModel={setOpenDeleteModel}
            groupId={id}
            selectedItem={selectedItem}
            deleteDeviceMutate={deleteDeviceMutate}
          />
        )} */}
          {openUploadCertificateModel && (
            <UploadCertificateModel
              postUploadCertificate={postUploadCertificate}
              uploadCertificateLoading={UploadCertificateLoading}
              setOpenUploadCertificateModel={setOpenUploadCertificateModel}
              selectedItem={selectedItem}
            />
          )}
          {openUpdateStatusModel && (
            <UpdateStatusModel
              postUpdateStatus={postUpdateStatus}
              updateStatusLoading={UpdateStatusLoading}
              paymentData={paymentData}
              setOpenUpdateStatusModel={setOpenUpdateStatusModel}
              groupId={id}
              selectedItem={selectedItem}
              userType={user.userType}
            />
          )}
          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              gTypeOfGame={gTypeOfGame}
            />
          )}
          {openViewRemarksModel && (
            <ViewRemarksModel
              setOpenViewRemarksModel={setOpenViewRemarksModel}
              selectedItem={selectedItem}
            />
          )}
          {/* {openDeleteModel && (
            <DeleteModel
              deleteDeviceLoading={deleteDeviceLoading}
              setOpenDeleteModel={setOpenDeleteModel}
              selectedData={selectedData}
              selectedItem={selectedItem}
              deleteDeviceMutate={deleteDeviceMutate}
              deviceId={selectedItem.id}
            />
          )} */}
          {openDeleteModel && (
            <DeleteModel
              deleteDeviceLoading={deleteDeviceLoading}
              setOpenDeleteModel={setOpenDeleteModel}
              selectedData={selectedData}
              selectedItem={selectedItem}
              deleteDeviceMutate={deleteDeviceMutate}
              deviceId={selectedItem.id}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              <Table
                ApiData={
                  error || data?.data.data == false ? [] : data?.data.data
                }
                setOpenDeleteModel={setOpenDeleteModel}
                setSelectedItem={setSelectedItem}
                setOpenUpdateStatusModel={setOpenUpdateStatusModel}
                setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                setOpenViewModel={setOpenViewModel}
                setOpenViewRemarksModel={setOpenViewRemarksModel}
                openConsentModel={openConsentModel}
                generateCertificate={generateCertificate}
                setDeviceId={setDeviceId}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, InitialLoading, user, t }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Start_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">{t("End_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Date_filter")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};


const TypeFilters = ({
  filter,
  initialValues,
  submitHandlerTypeSearch,
  InitialLoading,
  setFilter,
  setFilterValue,
  user,
  t,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandlerTypeSearch}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
            <Label htmlFor="filter">{t("Search")}</Label>

            <Select
              autoComplete="off"
              className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
              style={{ height: "40px" }}
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                //searchHandler(e.target.value);
              }}
            >
               <MenuItem value="0">All</MenuItem>
                <MenuItem value="1">Pending Docs</MenuItem>
                <MenuItem value="2">Pending Payments</MenuItem>
                <MenuItem value="3">InProgress</MenuItem>
                <MenuItem value="4">Approved By Asst</MenuItem>
                <MenuItem value="5">Completed</MenuItem>
                <MenuItem value="6">Certificate Issued</MenuItem>
                <MenuItem value="10">Rejected</MenuItem>
            </Select>
          </InputGroup>
          <InputGroup className="max-w-xs">
            <Label htmlFor="filterVal">{t("Value")}</Label>
            <FieldWrapper className="h-10">
              <Field
                type="text"
                name="filterVal"
                id="filterVal"
                class="ml-1"
                //value={filterValue}
                onSubmit={(e) => {
                  setFilterValue(e.target.value);
                  //searchHandler(e.target.value);
                }}
                //  onSubmit={(e) => {
                //   setFilterValue(e.target.value);
                //   //searchHandler(e.target.value);
                // }}
              />
            </FieldWrapper>
          </InputGroup>
          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Search")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

// const Uploader = ({ setOpenUploadModel }) => {
//   return (
//     <UploadWrapper>
//       <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
//       </Button>
//       {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
//       </Button> */}
//     </UploadWrapper>
//   );
// };

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default Applications;
